import React, { useState } from "react";
import MainStore from "../stores/MainStore";
import Counters from "./Counters";
import ActiveMood from "./ActiveMood";
import OnlineStatus from "./OnlineStatus";
import PlayedInfo from "./PlayedInfo";
import PlayerName from "./PlayerName";
import PlayerOptions from "./PlayerOptions";
import VerifyPlayer from "./VerifyPlayer";

const Player = ({ setActiveMood, openArea, areaOpen, closeBoxTypeArea }) => {
  const { player } = MainStore();
  const [showVerifiyButtons, setShowVerifyButtons] = useState(false);

  return (
    <div
      className="divColumn"
      style={{
        width: "250px",
        position: "absolute",
        right: "0px",
        padding: "5px",
      }}
    >
      <PlayerName
        showVerifiyButtons={showVerifiyButtons}
        setShowVerifyButtons={setShowVerifyButtons}
      />
      <ActiveMood setActiveMood={setActiveMood} />
      {showVerifiyButtons && <VerifyPlayer />}
      <OnlineStatus />
      <Counters closeBoxTypeArea={closeBoxTypeArea} />
      <PlayedInfo player={player} />
      <PlayerOptions player={player} openArea={openArea} areaOpen={areaOpen} />
    </div>
  );
};

export default Player;
